import React, { PureComponent } from 'react'
import compose from 'recompose/compose'
import injectSheet from 'react-jss'
import ReactIScroll from 'react-iscroll'
import iScroll from 'iscroll'
import RegistrationPage1 from './registrationPage1'
import RegistrationPage2 from './registrationPage2'
import RegistrationPageContexts from '../RegistrationPageContexts'
import colors from 'aria-viewer/tour/constants/style/colors'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import CloseButton from 'aria-viewer/tour/components/buttons/closeButton'

const styleSheet = theme => ({
    wrapper: {
        paddingTop: '10px',
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
        position: 'absolute',
    },
    mobileFormWrapper: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'calc(100% - 20px)',
        maxWidth: '440px',
        height: 'calc(100% - 164px)',
        background: colors.white,
        borderRadius: '4px',
        zIndex: '20000',
    },
    reactIScroll: {
        height: 'calc(100% - 30px)',
        overflow: 'hidden',
    },
    registrationForm: {
        position: 'relative',
        width: 'calc(100% - 40px)',
        padding: '30px 20px 15px',
        borderRadius: '4px',
        zIndex: '1',
    },
    registrationFormTitle: {
        width: '100%',
        background: colors.white,
        textAlign: 'center',
        fontWeight: styleguide.fonts.weight.bold,
        fontSize: 24,
    },
    bottomContainer: {
        position: 'absolute',
        width: '100%',
        height: 164,
        zIndex: 100000,
        bottom: 0,
    },
    registrationPolicyContainer: {
        lineHeight: `1.5`,
        width: `100%`,
        height: `42px`,
        fontFamily: `CircularStd, Circular Std Book`,
        fontSize: `14px`,
        color: `#9b9b9b`,
        position: `relative`,
        top: 20,

        '& .registration-mobile-policy': {
            width: `307px`,
            margin: `0 auto`,
        },

        '& .policy-agreement.small': {
            lineHeight: `1.3`,
            fontSize: `13px`,
        },

        '& a': {
            color: `#000000`,
        },
    },
    poweredByContainer: {
        width: `100%`,
        top: 28,
        position: 'relative',
        textAlign: 'center',
    },
    poweredBy: {
        fontFamily: `CircularStd, Circular Std Book`,
        color: `#4a90e2`,
        height: 15,
        fontSize: 12,
        margin: `0 auto`,
        display: `block`,
    },
    closeButton: {
        position: 'absolute',
        top: '2px',
        right: '2px',
        width: '16px !important',
        height: '16px !important',
        margin: '24px',
        background: colors.white,
        borderRadius: '50%',
        zIndex: 20000,
        '& .icon_close_svg polygon': {
            fill: '#D4D6D9',
        },
        '@media screen and (orientation: landscape)': {
            top: 48,
            right: 48,
        },
    },
})

class MobileRegistrationForm extends PureComponent {
    constructor(props) {
        super(props)
    }

    render() {
        const {
            handleFocusField,
            handleChange,
            registrationForm,
            registrationPageContext,
            width,
            height,
            location,
            fields,
            registration,
            submitIndex,
            title,
            scrollOptions,
            isRegistrationPrompt,
            registrationPage1Loaded,
            setRegistrationForm,
            updateField,
            handleFieldError,
            handleResumePageScroll,
            registrationPage2Loaded,
            registrationSuccess,
            registrationSubmitted,
            isPhone,
            closeRegistration,
            showFormButton,
            getTagLine,
            classes,
            forwardRef,
            policySection,
            logoPoweredBy,
        } = this.props

        return (
            <div className={classes.wrapper}>
                <div className={classes.mobileFormWrapper}>
                    <ReactIScroll
                        ref={forwardRef}
                        iScroll={iScroll}
                        options={scrollOptions}
                        className={classes.reactIScroll}
                    >
                        <div className={classes.registrationForm}>
                            <div className={classes.registrationFormTitle}>{title}</div>
                            {registrationPageContext == RegistrationPageContexts.DESKTOP_LANDING && (
                                <RegistrationPage1
                                    fields={fields}
                                    height={height}
                                    width={width * (height > width ? 0.8 : 0.5)}
                                    submitIndex={submitIndex}
                                    handleFocusField={handleFocusField}
                                    handleChange={handleChange}
                                    formInfo={
                                        isRegistrationPrompt ? registrationForm.prompt : registrationForm.register
                                    }
                                    onLoad={registrationPage1Loaded}
                                />
                            )}
                            {registrationPageContext == RegistrationPageContexts.AFTER_LANDING && (
                                <RegistrationPage2
                                    ref={'registrationForm2'}
                                    experienceName={location.name}
                                    fields={fields}
                                    tagline={getTagLine}
                                    registrationForm={registration}
                                    bindRegistration={setRegistrationForm}
                                    handleFieldChange={updateField}
                                    handleFocusField={handleFocusField}
                                    handleFieldError={handleFieldError}
                                    handleResumePageScroll={handleResumePageScroll}
                                    onLoad={registrationPage2Loaded}
                                    onRegistrationSuccess={registrationSuccess}
                                    onRegistrationSubmitted={registrationSubmitted}
                                    mobile={isPhone}
                                    policyContainerRef={this.refs.policyContainer}
                                />
                            )}
                        </div>
                    </ReactIScroll>
                </div>
                <CloseButton onClick={closeRegistration} puresvg={true} className={classes.closeButton} />
                <div className={classes.bottomContainer}>
                    {showFormButton}
                    <div className={classes.registrationPolicyContainer} ref="policyContainer" />
                    <div className={classes.poweredByContainer}>
                        <a
                            href="https://www.youvisit.com/"
                            alt="Registration Powered-by-YouVisit"
                            className="reg-newtab-link"
                            target="_blank"
                        >
                            <span className={classes.poweredBy}>Powered by YouVisit</span>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default compose(injectSheet(styleSheet))(MobileRegistrationForm)
